<div class="section" id="gabinet">
  <div class="container">
    <div class="text-center">
      <h1 class="title">Gabinet fizjoterapii i rehabilitacji w Gliwicach {{ company.NAME_COMPACT }}</h1>
      <hr class="section-hr reveal fade-width"/>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <p class="description text-justify text-center mb-4">
          <b>
            Dobre zrozumienie problemu to pierwszy krok do właściwej terapii
          </b>
        </p>
        <p class="description text-justify mb-4">
          W gabinecie {{ company.NAME_COMPACT }} zaczynamy współpracę od wywiadu i dokładnego poznania Twojego problemu.
          Znaczenie ma nie tylko miejsce występowania bólu czy postawiona wcześniej diagnoza, ale również sposób, w jaki
          problem się pojawił, jak zmieniał się w czasie i jak wpływa na Twoje funkcjonowanie. Na tej podstawie oceniamy
          problem, rozpoczynamy terapię i określamy dalszy kierunek postępowania.
        </p>
        <p class="description text-justify mb-4">
          Ból kręgosłupa, barku, kolana czy innego stawu, ograniczenie ruchu, przeciążenie, kontuzja sportowa lub
          nawracające dolegliwości mogą mieć różne przyczyny i wymagać odpowiedniego podejścia. Dotyczy to również
          problemów, których źródło nie jest od początku oczywiste.
        </p>
        <p class="description text-justify mb-4">
          Zajmuję się zarówno częstymi dolegliwościami układu ruchu, jak i bardziej złożonymi przypadkami —
          przewlekłymi, nawracającymi lub takimi, w których dotychczasowe leczenie nie przyniosło oczekiwanej poprawy.
          Jednym z głównych kierunków mojej pracy jest terapia powięziowa, którą wykorzystuję w procesie fizjoterapii i
          terapii manualnej, dobierając sposób postępowania do charakteru danego problemu.
        </p>
        <p class="description text-justify mb-4">
          Jestem fizjoterapeutą z wieloletnim doświadczeniem klinicznym. Od lat konsekwentnie rozwijam swój warsztat,
          szczególnie w zakresie terapii powięziowej, terapii manualnej i fizjoterapii ortopedycznej.
        </p>
        <p class="description text-justify text-center mb-4">
          <b>
            Jakie usługi m.in. świadczę w moim gabinecie Fizjoterapii w Gliwicach?
          </b>
        </p>
        <br/>
        <div>
          <br/><br/>
          <div ngbAccordion [closeOthers]="true">
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- pierwsza wizyta diagnostyczno-terapeutyczna</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>
                      konsultacja fizjoterapeutyczna w Gliwicach składa się z <b>obszernego wywiadu, zapoznania się z
                      dokumentacją medyczną</b> oraz <b>badania funkcjonalnego, ortopedycznego i neurologicznego</b>,
                    </li>
                    <li>
                      podczas konsultacji fizjoterapeutycznej wykonywana jest również terapia.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- terapia mięśniowo-powięziowa</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>dolegliwości spowodowane stresem i napięciem mięśniowym,</li>
                    <li>przewlekłe bóle stawów i mięśni,</li>
                    <li>terapia powięziowa przy bólach głowy i migrenach,</li>
                    <li>terapia mięśniowo-powięziowa w leczeniu bólu pleców oraz kończyn,</li>
                    <li>zastosowanie terapii mięśniowo-powięziowej w sztywności mięśni i stawów,</li>
                    <li>terapia po zabiegach operacyjnych, kontuzjach sportowych,</li>
                    <li>dolegliwości <b>"niewiadomego"</b> pochodzenia,</li>
                    <li>i wiele wiele innych...</li>
                  </ul>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- suche igłowanie</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>leczenie bólu mięśni i stawów,</li>
                    <li>praca z blizną po operacji lub szyciu,</li>
                    <li>rozluźnienie nadmiernie napiętych mięśni,</li>
                    <li>leczenie bóli promieniujących w obrębie kończyn górnych i dolnych,</li>
                    <li>suche igłowanie pod kontrolą USG.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- leczenie bólu kręgosłupa</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>rehabilitacja dyskopatii,</li>
                    <li>leczenie przepukliny dysku międzykręgowego,</li>
                    <li>fizjoterapia rwy kulszowej,</li>
                    <li>fizjoterapia rwy barkowej,</li>
                    <li>leczenie bólu odcinka lędźwiowego, szyjnego, barku, łokcia, nadgarstka,</li>
                    <li>dysfunkcje i ból kręgosłupa,</li>
                    <li>podrażnienie układu nerwowego.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- fizjoterapia bólu mięśni i stawów</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>bóle mięśni i stawów,</li>
                    <li>ograniczenia ruchu w stawach,</li>
                    <li>leczenie drętwienia/mrowienia/promieniowania kończyn lub palców,</li>
                    <li>fizjoterapia bólu przeciążonych mięśni,</li>
                    <li>i wiele wiele innych...</li>
                  </ul>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- rehabilitacja sportowa i leczenie kontuzji</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>rehabilitacja po skręceniu kostki, palców czy stawu kolanowego,</li>
                    <li>leczenie złamań i zwichnięć (np. barku czy stawu skokowego),</li>
                    <li>fizjoterapia po zerwaniu więzadeł lub naciągnięciu mięśni,</li>
                    <li>bóle pojawiające się podczas aktywności (bieg, rzut, kopnięcie),</li>
                    <li>niestabilność stawów (uciekające kolano, bark, kostka),</li>
                    <li>...oraz wiele innych urazów i kontuzji.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div ngbAccordionItem>
              <div ngbAccordionHeader aria-level="1">
                <button ngbAccordionButton>
                  <b>- rehabilitacja po artroskopii i operacjach stawów</b>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ul>
                    <li>rehabilitacja po artroskopii kolana, biodra i barku,</li>
                    <li>fizjoterapia po operacji kręgosłupa,</li>
                    <li>zabiegi operacyjne dla cieśni nadgarstka,</li>
                    <li>rehabilitacja po endoprotezie biodra/kolana itp.,</li>
                    <li>i wiele wiele innych...</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 text-center pt-0 mt-0 pt-lg-5 mt-lg-5">
        <img ngSrc="assets/{{profileImage.NAME}}" class="img-fluid mt-5" [alt]="profileImage.ALT"
             [height]="profileImage.HEIGHT" [width]="profileImage.WIDTH">
      </div>
    </div>
  </div>
</div>
